import * as React from "react";
import type { Side } from "../../core/types";

export type SelectedHole = {
  side: Side;
  index: number;
  storeClicked?: boolean;
};
const SelectedHoleContext: React.Context<SelectedHole | undefined> = React.createContext<SelectedHole | undefined>(
  undefined
);
export default SelectedHoleContext;
